export default __webpack_public_path__ + "static/media/pic2.c00495c5.png";